import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import styled from "styled-components";
import request from "superagent";
import * as UserActions from "../../redux/actions/user";
import * as SearchActions from "../../redux/actions/search";
import * as ShopifyActions from "../../redux/actions/shopify";
import downloadAllVideosPlaylists from "./account/userPanel/components/playlist/services/downloadAllVideosPlaylists";
import fetchPurchases from "redux/actions/history/handlers/fetchPurchases";

import Header from "../../components/header";
import Footer from "../../components/footer";
import { AddToListModal, AddToListModalMultipleVideos } from "../../components/shared";
import DigitalTermsModal from "../../components/shared/DigitalTermsModal";
import BroadcastTermsModal from "../../components/shared/BroadcastTermsModal";
import Analytics from "../../helpers/analytics";

const ContainerComponent = styled.div``;
const Content = styled.div``;

function Container(props) {
  const showFilter = useSelector((state) => state.pages.search.showFilter);
  const {
    auth,
    children,
    headerSticky,
    closeAddToListModal,
    closeAddToListMultipleVideosModal,
    fetchPurchases
  } = props;
  const [analyticsSend, setAnalyticsSend] = useState(false);

  const servicate = (auth) => {
    window._sva = window._sva || {};
    if (window._sva) {
      window._sva.traits = {
        email: auth.userProfile.profile.email,
        first_name:
          auth.userProfile.profile.firstName !== null ? auth.userProfile.profile.firstName : "N/A",
        last_name:
          auth.userProfile.profile.lastName !== null ? auth.userProfile.profile.lastName : "N/A",
        organization:
          auth.userProfile.profile.company !== null ? auth.userProfile.profile.company : "N/A",
        phone:
          auth.userProfile.profile.phoneNumber !== null
            ? auth.userProfile.profile.phoneNumber
            : "N/A"
      };
    }
  };

  useEffect(() => {
    Analytics.page();
    closeAddToListModal();
    closeAddToListMultipleVideosModal();
  }, []);

  useEffect(() => {
    if (
      auth.loggedIn &&
      auth.userProfile &&
      auth.userProfile.profile &&
      auth.userProfile.profile.id &&
      !analyticsSend.identify
    ) {
      Analytics.plugins.enable("hubspot").then(() => {
        if (auth.userProfile.profile.newsletter) {
          request
            .post(process.env.REACT_APP_NEWSLETTER_HOST)
            .send({
              company: auth.userProfile.profile.company,
              email: auth.userProfile.profile.email,
              firstName: auth.userProfile.profile.firstName,
              lastName: auth.userProfile.profile.lastName,
              phoneNumber: auth.userProfile.profile.phoneNumber,
              newsletter: auth.userProfile.profile.newsletter
            })
            .then((res) => {});
        }
        Analytics.identify(auth.userProfile.profile.id.toString(), {
          email: auth.userProfile.profile.email,
          firstName: auth.userProfile.profile.firstName,
          lastName: auth.userProfile.profile.lastName,
          phoneNumber: auth.userProfile.profile.phoneNumber,
          dateCreated: auth.userProfile.profile.dateCreated,
          lastLogin: new Date(),
          dimension1: auth.userProfile.profile.company,
          dimension5: auth.userProfile.profile.id,
          jm_account_owner: true
        });
      });

      setAnalyticsSend((prev) => !prev);
      servicate(auth);
    }
    setTimeout(() => {
      document.getElementsByClassName("footerCopyright")[0] &&
        document
          .getElementsByClassName("footerCopyright")[0]
          .style.setProperty("color", "#1EBEC8", "important");
      document.getElementsByClassName("infringement-form footerUrl")[0] &&
        document.getElementsByClassName("infringement-form footerUrl")[0].remove();
    }, 500);
  }, [auth.loggedIn]);

  useEffect(() => {
    if (auth.loggedIn) {
      fetchPurchases();
    }
  }, []);

  return (
    <ContainerComponent id="wrapper" className={showFilter ? "search__filter--visible" : ""}>
      <Header headerSticky={headerSticky !== undefined ? headerSticky : true} {...props} />
      <Content>{children}</Content>
      <AddToListModal {...props} />
      <AddToListModalMultipleVideos {...props} />
      <DigitalTermsModal {...props} />
      <BroadcastTermsModal {...props} />
      {!props.disableFooter && <Footer />}
    </ContainerComponent>
  );
}

Container.propTypes = {
  headerSticky: PropTypes.bool,
  user: PropTypes.shape().isRequired,
  search: PropTypes.shape().isRequired,
  auth: PropTypes.shape().isRequired
};

function mapStateToProps(state) {
  let { user, search, auth, shopify, playlists } = state;

  return {
    user,
    search,
    auth,
    shopify,
    playlists
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...UserActions,
      ...SearchActions,
      ...ShopifyActions,
      downloadAllVideosPlaylists,
      fetchPurchases
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Container);
